import { Component } from 'react';

/**
 * Lazy-loads a store's LATEST store-check by id when the drawer opens (or the check changes).
 */
export default class StoreCategoryDrawerController extends Component {
    componentDidUpdate() {
        const { open, checkId } = this.props;
        if (open && checkId && checkId !== this.state.loadedId && !this.state.loading) {
            this.load(checkId);
        }
    }

    async load(checkId) {
        this.setState({ loading: true, loadedId: checkId, check: null });
        try {
            const res = await this.props.data.fetchStoreCheckById(checkId);
            this.setState({ check: res?.data || res || null, loading: false });
        } catch {
            this.setState({ loading: false });
        }
    }

    // Categories worth showing: with photos or with faces counted.
    visibleCategories() {
        const { check } = this.state;
        return (check?.categories || []).filter((c) => c?.imagesBefore?.length || c?.imagesAfter?.length || c?.totalFaces > 0);
    }
}
